// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangePassword_wrapper__7+VlJ","inputSpace":"ChangePassword_inputSpace__OLAVj","buttonToRight":"ChangePassword_buttonToRight__ziTYi","row":"ChangePassword_row__T5R24"};